module.exports = __webpack_public_path__ + "static/media/quality.2a98e394.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/quality.svg
// module id = 270
// module chunks = 0